import React, { useState } from "react";
import { BrowserRouter as Router, Routes, Route } from "react-router-dom";

import Login from "./pages/loginpage";
import Queuepage from "./pages/queuepage";
import Homepage from "./pages/homepage";
import Dialpad from "./pages/dialpad";
import ProtectedRoute from "./ProtectedRoute";

function App() {
  const [loggedInUser, setLoggedInUser] = useState(null);

  const handleLogin = (username) => {
    setLoggedInUser(username);
  };

  return (
    <Router>
      <Routes>

        {/* Public Route */}
        <Route path="/" element={<Login onLogin={handleLogin} />} />

        {/* Protected Routes */}
        <Route element={<ProtectedRoute />}>
          <Route path="/queuepage" element={<Queuepage />} />
          <Route path="/homepage" element={<Homepage />} />
          <Route path="/dialpadpage" element={<Dialpad />} />
        </Route>

        {/* Block unknown routes */}
        <Route path="*" element={<ProtectedRoute />} />

      </Routes>
    </Router>
  );
}

export default App;